import React, { useEffect, useState } from "react";
import CustomComonent from "./CustomComonent";
import userResources from "api/userResources";

export default function EmployeeSales() {
  const [employeeData, setEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getEmployee = async () => {
    setIsLoading(true); // Set loading state to true when fetching starts
    try {
      const response = await userResources.adminemployeeslist();
      const data = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setEmployeeData(data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setIsLoading(false); // Set loading state to false when fetching ends
    }
  };

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    <div>
      <CustomComonent
        employeeSales={{
          employeetrue: true,
          employeeData: employeeData,
          employeeLoading: isLoading,
        }}
      />
    </div>
  );
}
